module.exports = __webpack_public_path__ + "registration-form-ca2d4608/background-bf0cd5740250d8de53a3c4542317da8f.png";